import { createContext, useContext } from 'react';

export const LayoutScrollContext = createContext(false);

export const useLayoutScroll = () => useContext(LayoutScrollContext);
